import { selfAxios } from "../../../../axios/selfAxios.js";
async function postFindActivityRemainAmountListByCustomerId(params) {
  const { data } = await selfAxios.post(`/designordercenter/activityOrderController/findActivityRemainAmountListByCustomerId`, params);
  return data == null ? void 0 : data.data;
}
export { postFindActivityRemainAmountListByCustomerId };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/designordercenter/activityOrderController/findActivityRemainAmountListByCustomerId/post.js